class StateCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.dotsContainer = this.querySelector('[data-dots]');
    if (!this.track || !this.dotsContainer) return;

    this.slides = Array.from(this.track.children);
    this.autoplayMs = Number(this.dataset.autoplay) || 0;
    this.activeIndex = 0;

    this.dotsContainer.innerHTML = '';
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'state-carousel__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', () => {
        this.goTo(i);
        this.stopAutoplay();
      });
      this.dotsContainer.appendChild(dot);
    });
    this.dots = Array.from(this.dotsContainer.children);
    this.updateDots();

    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.goTo(this.activeIndex - 1);
        this.stopAutoplay();
      });
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.goTo(this.activeIndex + 1);
        this.stopAutoplay();
      });
    }

    this.handleScroll = () => this.onScroll();
    this.track.addEventListener('scroll', this.handleScroll, { passive: true });
    this.track.addEventListener('pointerdown', () => this.stopAutoplay(), { passive: true });

    if (this.autoplayMs) this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    if (this.track && this.handleScroll) {
      this.track.removeEventListener('scroll', this.handleScroll);
    }
  }

  // Step size = one slide's rendered width + track gap. This is what lets
  // the same carousel show 1-at-a-time (mobile) or N-at-a-time (desktop,
  // via CSS flex-basis) without any breakpoint-specific JS branching.
  slideStep() {
    const first = this.slides[0];
    if (!first) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  onScroll() {
    const step = this.slideStep();
    if (!step) return;
    const index = Math.round(this.track.scrollLeft / step);
    const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
    if (clamped !== this.activeIndex) {
      this.activeIndex = clamped;
      this.updateDots();
    }
  }

  updateDots() {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.activeIndex);
    });
  }

  goTo(index) {
    const length = this.slides.length;
    this.activeIndex = ((index % length) + length) % length;
    const step = this.slideStep();
    this.track.scrollTo({ left: this.activeIndex * step, behavior: 'smooth' });
    this.updateDots();
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      this.goTo(this.activeIndex + 1);
    }, this.autoplayMs);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('state-carousel')) {
  customElements.define('state-carousel', StateCarousel);
}
